import { render } from "./ViewSelector.vue?vue&type=template&id=50f1b8f7&scoped=true"
import script from "./ViewSelector.vue?vue&type=script&lang=js"
export * from "./ViewSelector.vue?vue&type=script&lang=js"

import "./ViewSelector.vue?vue&type=style&index=0&id=50f1b8f7&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-50f1b8f7"]])

export default __exports__